import { TableColumnModelExtended } from 'common/src/models/table-column.model';
import {
  HighlightTypeEnum,
  TableSummaryBarItemModel,
  TableSummaryBarItemTypeEnum
} from 'common/src/modules/ui-components/table-summary-bar/table-summary-bar.model';
import { DataImportResponseModel } from 'projects/workspace/src/app/data-import/models/data-import-response.model';
import { DataImportEntityEnum } from 'projects/workspace/src/app/data-import/models';

// export const SUCCESS_MODAL_BTN_CONFIG = {
//   [DataImportEntityEnum.GOODS]: {
//     title: 'DATA_IMPORT.OPEN_GOODS',
//     link: `/products/${ProductTypes.GOODS}`
//   },
//   [DataImportEntityEnum.SERVICES]: {
//     title: 'DATA_IMPORT.OPEN_SERVICES',
//     link: `/products/${ProductTypes.SERVICES}`,
//   },
//   [DataImportEntityEnum.DIGITAL_PRODUCTS]: {
//     title: 'DATA_IMPORT.OPEN_DIGITAL',
//     link: `/products/${ProductTypes.DIGITAL}`,
//   },
//   [DataImportEntityEnum.CORPORATE_PARTNERS]: {
//     title: 'DATA_IMPORT.OPEN_CP',
//     link: '/partners-new/corporate',
//   },
//   [DataImportEntityEnum.PRIVATE_PARTNERS]: {
//     title: 'DATA_IMPORT.OPEN_PP',
//     link: '/partners-new/private',
//   },
//   [DataImportEntityEnum.PRICES]: {
//     title: 'DATA_IMPORT.OPEN_PRICES',
//     link: '/trade/prices/'
//   },
//   [DataImportEntityEnum.STOCK_STATUS]: {
//     title: 'DATA_IMPORT.OPEN_STOCK_DATA',
//     link: '/warehouse/stock-status/'
//   },
// };

export function getColumnsByImportType(entityType: DataImportEntityEnum): TableColumnModelExtended[] {
  let columns: TableColumnModelExtended[] = [];

  switch (entityType) {
    case DataImportEntityEnum.GOODS:
      columns = GOODS_COLUMNS;
      break;
    case DataImportEntityEnum.SERVICES:
      columns = SERVICES_COLUMNS;
      break;
    case DataImportEntityEnum.DIGITAL_PRODUCTS:
      columns = DIGITAL_COLUMNS;
      break;
    case DataImportEntityEnum.CORPORATE_PARTNERS:
      columns = CORPORATE_PARTNERS_COLUMNS;
      break;
    case DataImportEntityEnum.PRIVATE_PARTNERS:
      columns = PRIVATE_PARTNERS_COLUMNS;
      break;
    case DataImportEntityEnum.PRICES:
      columns = PRICES_COLUMNS;
      break;
    case DataImportEntityEnum.STOCK_STATUS:
      columns = STOCK_DATA_COLUMNS;
      break;
    case 'IIN' as any: // todo: remove after back changed to 'PMNT'
    case 'PMNT' as any:
      columns = PAYMENTS_COLUMNS;
      break;
    case DataImportEntityEnum.PARTNER_ACCOUNT:
      columns = PARTNER_ACCOUNT_COLUMNS;
      break;
  }

  return columns;
}

export const COMMON_COLUMNS: TableColumnModelExtended[] = [
  {
    cellTemplate: 'withIconPrimary',
    headerTemplate: 'headerPrimary',
    name: '',
    prop: 'rowStatusData',
    sortable: false,
    width: 40,
    maxWidth: 40,
  },
  {
    cellTemplate: 'numberRows',
    cellClass: 'center',
    name: 'Nr.',
    width: 40,
    maxWidth: 40,
    sortable: false,
    resizeable: false,
    headerClass: 'center'
  },
];

export const ADDRESS_COLUMNS: TableColumnModelExtended[] = [
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.COUNTRY',
    prop: 'countryIso3',
    width: 170,
    maxWidth: 170,
    sortable: false,
    showRowCountry: true,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.POSTAL_CODE',
    prop: 'postalCode',
    width: 100,
    maxWidth: 100,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.CITY',
    prop: 'city',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.STREET',
    prop: 'street',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.HOUSE',
    prop: 'house',
    width: 70,
    maxWidth: 70,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.DOOR',
    prop: 'door',
    width: 70,
    maxWidth: 70,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.EMAIL',
    prop: 'email',
    width: 170,
    sortable: false,
  },
];

export const PHONE_NUMBER_COLUMN: TableColumnModelExtended =  {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'COLUMN.PHONE_NUMBER',
  prop: 'phone',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const NAME_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'COLUMN.NAME',
  prop: 'name',
  width: 270,
  maxWidth: 270,
  sortable: false,
};

export const PARTNER_ID_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'FORM.PARTNER_ID',
  prop: 'runpleId',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const ITEM_NUMBER_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'PRODUCTS.MANUFACTURER_CODE',
  prop: 'itemNumber',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const RUNPLE_ID_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'PRODUCTS.ARTICLE_NUMBER',
  prop: 'runpleId',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const BARCODE_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'FORM.BARCODE',
  prop: 'ean',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const DESCRIPTIONS_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'FORM.DESCRIPTION',
  prop: 'description',
  // width: 470,
  // maxWidth: 470,
  sortable: false,
  sourceTextFormat: true,
};

export const SALES_PRICE_NET_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'SO_PO.SALES_PRICE_NET',
  prop: 'salesPriceNet',
  additionalText: '€', // todo: add from workspace currency
  currencyConversion: true,
  width: 200,
  maxWidth: 200,
  sortable: false,
};

export const PURCHASE_PRICE_NET_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'COLUMN.PURCHASE_PRICE_NET',
  prop: 'purchasePrice',
  additionalText: '€', // todo: add from workspace currency
  currencyConversion: true,
  width: 200,
  maxWidth: 200,
  sortable: false,
};

export const SALES_PRICE_VAT_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'OCR.VAT_RATE',
  prop: 'salesPriceVat',
  additionalText: '%',
  vatRateFormat: true,
  width: 120,
  maxWidth: 120,
  sortable: false,
};

export const SEPA_MANDAT_ID_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'SEPA_EXPORT.MANDAT_ID',
  prop: 'mandatId',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const SEPA_SEQUENCE_TYPE_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'SEPA_EXPORT.SEQUENCE_TYPE',
  prop: 'sequenceType',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const SEPA_SIGNATURE_DATE_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'SEPA_EXPORT.SIGNATURE_DATE',
  prop: 'signatureDate',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const SEPA_SCHEME_COLUMN: TableColumnModelExtended = {
  cellTemplate: 'withCellCustomClass',
  headerTemplate: 'headerPrimary',
  name: 'SEPA_EXPORT.SCHEME',
  prop: 'scheme',
  width: 170,
  maxWidth: 170,
  sortable: false,
};

export const SERVICES_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  RUNPLE_ID_COLUMN,
  NAME_COLUMN,
  DESCRIPTIONS_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.PRIME_COST_NET',
    additionalText: '€', // todo: add from workspace currency
    currencyConversion: true,
    prop: 'primeCosts',
    width: 200,
    maxWidth: 200,
    sortable: false,
  },
  SALES_PRICE_NET_COLUMN,
  SALES_PRICE_VAT_COLUMN,
];

export const GOODS_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  RUNPLE_ID_COLUMN,
  ITEM_NUMBER_COLUMN,
  BARCODE_COLUMN,
  NAME_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'PRODUCTS.MANUFACTURER',
    prop: 'manufacturer',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'PRODUCTS.MODEL',
    prop: 'model',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'DATA_IMPORT.COLOR',
    prop: 'color',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  DESCRIPTIONS_COLUMN,
  PURCHASE_PRICE_NET_COLUMN,
  SALES_PRICE_NET_COLUMN,
  SALES_PRICE_VAT_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.QUANTITY',
    prop: 'stockQuantity',
    additionalText: 'pcs',
    unitTypeShortcut: true,
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
];

export const DIGITAL_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  RUNPLE_ID_COLUMN,
  ITEM_NUMBER_COLUMN,
  NAME_COLUMN,
  DESCRIPTIONS_COLUMN,
  PURCHASE_PRICE_NET_COLUMN,
  SALES_PRICE_NET_COLUMN,
  SALES_PRICE_VAT_COLUMN,
];

export const CORPORATE_PARTNERS_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  PARTNER_ID_COLUMN,
  NAME_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.ALIAS',
    prop: 'alias',
    width: 240,
    maxWidth: 240,
    sortable: false,
  },
  ...ADDRESS_COLUMNS,
  PHONE_NUMBER_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.VAN_NUMBER',
    prop: 'vat',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.IBAN',
    prop: 'iban',
    width: 170,
    sortable: false,
  },
  SEPA_MANDAT_ID_COLUMN,
  SEPA_SIGNATURE_DATE_COLUMN,
  SEPA_SEQUENCE_TYPE_COLUMN,
  SEPA_SCHEME_COLUMN,
];

export const PRIVATE_PARTNERS_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  PARTNER_ID_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.FIRST_NAME',
    prop: 'firstName',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.LAST_NAME',
    prop: 'lastName',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  ...ADDRESS_COLUMNS,
  PHONE_NUMBER_COLUMN,
  SEPA_MANDAT_ID_COLUMN,
  SEPA_SIGNATURE_DATE_COLUMN,
  SEPA_SEQUENCE_TYPE_COLUMN,
];

export const PRICES_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  RUNPLE_ID_COLUMN,
  ITEM_NUMBER_COLUMN,
  BARCODE_COLUMN,
  {
    ...NAME_COLUMN,
    maxWidth: null
  },
  PURCHASE_PRICE_NET_COLUMN,
  SALES_PRICE_NET_COLUMN,
  SALES_PRICE_VAT_COLUMN,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.DISCOUNT_PERCENT',
    prop: 'discount',
    additionalText: '%',
    width: 150,
    maxWidth: 150,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.DISCOUNT_NET',
    prop: 'discountNet',
    additionalText: '€', // todo: add from workspace currency
    currencyConversion: true,
    width: 200,
    maxWidth: 200,
    sortable: false,
  },
];

export const STOCK_DATA_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  RUNPLE_ID_COLUMN,
  ITEM_NUMBER_COLUMN,
  BARCODE_COLUMN,
  {
    ...NAME_COLUMN,
    maxWidth: null
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.BATCH',
    prop: 'batch',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.EXPIRATION_DATE',
    prop: 'expirationDate',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.QUANTITY',
    additionalText: 'pcs',
    unitTypeShortcut: true,
    prop: 'quantity',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.BIN_LOCATION',
    prop: 'binLocation',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
];

export const PAYMENTS_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.TYPE',
    prop: 'direction',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'APP.BUSINESS_PARTNER',
    prop: 'partnerName',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.BOOKING_DATE',
    prop: 'bookingDate',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.AMOUNT',
    prop: 'amount',
    width: 170,
    maxWidth: 170,
    // currencyConversion: true,
    sortable: false,
  },
  // {
  //   cellTemplate: 'withCellCustomClass',
  //   headerTemplate: 'headerPrimary',
  //   name: 'COMMON.CURRENCY',
  //   prop: 'currency',
  //   width: 70,
  //   maxWidth: 70,
  //   sortable: false,
  // },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.PAYMENT_METHOD',
    prop: 'paymentMethod',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'BANK_ACCOUNTS.BANK_ACCOUNT',
    prop: 'bankAccountIban',
    width: 210,
    maxWidth: 210,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'DATA_IMPORT.PARTNERS_IBAN',
    prop: 'iban',
    width: 210,
    maxWidth: 210,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'DATA_IMPORT.PARTNERS_BIC',
    prop: 'bic',
    width: 140,
    maxWidth: 140,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'FORM.PAYMENT_REFERENCE',
    prop: 'paymentReference',
    width: 310,
    // maxWidth: 310,
    sortable: false,
  },
];

export const PARTNER_ACCOUNT_COLUMNS: TableColumnModelExtended[] = [
  ...COMMON_COLUMNS,
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.PARTNER_ID',
    prop: 'partnerId',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COLUMN.PARTNER_NAME',
    prop: 'partnerName',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.EXTERNAL_ACCOUNT',
    prop: 'externalAccount',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.EXTERNAL_SUPPLIER_ACCOUNT',
    prop: 'externalSupplierAccount',
    width: 170,
    maxWidth: 170,
    sortable: false,
  },
  {
    cellTemplate: 'withCellCustomClass',
    headerTemplate: 'headerPrimary',
    name: 'COMMON.EXTERNAL_CUSTOMER_ACCOUNT',
    prop: 'externalCustomerAccount',
    // width: 170,
    // maxWidth: 170,
    // currencyConversion: true,
    sortable: false,
  },
];

export function getTableSummaryBarItems(importedData: DataImportResponseModel): TableSummaryBarItemModel[] {
  return [
    {
      label: 'DATA_IMPORT.ITEMS',
      type: TableSummaryBarItemTypeEnum.WITH_NUMBER,
      value: importedData.rowsCount,
      basisWidth: 167
    },
    {
      label: 'DATA_IMPORT.ERRORS',
      type: TableSummaryBarItemTypeEnum.WITH_NUMBER,
      highlightTypes: [HighlightTypeEnum.POSITIVE_TO_RED],
      value: importedData.errorsCount,
      displayed: !!importedData.errorsCount,
      basisWidth: 167
    },
    {
      label: 'DATA_IMPORT.READY',
      type: TableSummaryBarItemTypeEnum.WITH_NUMBER,
      value: importedData.readyCount,
      basisWidth: 167
    }
  ];
}
